import React, {useEffect} from 'react';
import {Box, IconButton, Stack, Typography} from '@mui/material';
import {Outlet, useNavigate, useParams} from 'react-router-dom';

import {ClientUnitDetailsRoutes} from '@utils/routes.utils';

import {ArrowBack} from '@icons/index';

import RoutesTabsComponent from '@components/tabs/RoutesTabs.component';
import {useObservable} from '@ngneat/react-rxjs';
import {clientsUnitsDetailsQuery, clientsUnitsDetailsService} from '@store/clients/units/details';
import {clientsServicesService} from '@store/clients/services';

const ClientUnitDetailsScreen = () => {
  const navigate = useNavigate();
  const {clientUnitId} = useParams();

  const [{headOffice}] = useObservable(clientsUnitsDetailsQuery.clientUnitDetails$);

  useEffect(() => {
    if (clientUnitId) {
      clientsUnitsDetailsService.getClientUnitById(clientUnitId).subscribe();
    }

    return () => {
      clientsUnitsDetailsService.resetStore();
      clientsServicesService.resetStore();
    };
  }, [clientUnitId]);

  if (!headOffice.name) return null;

  const handleClose = () => {
    navigate('..');
  };

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={3} overflow="hidden">
      <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1} ml="-9px">
        <IconButton onClick={handleClose}>
          <ArrowBack/>
        </IconButton>
        <Typography fontSize="30px" fontWeight="700">
          {headOffice?.name}
        </Typography>
      </Stack>
      <Stack flex={1} overflow="hidden">
        <Box>
          <RoutesTabsComponent routes={ClientUnitDetailsRoutes.routes()}/>
        </Box>
        <Outlet/>
      </Stack>
    </Stack>
  );
};

export default ClientUnitDetailsScreen;
